export const isElvisImageEmpty = (props) => !props?.imageUrl;
